import React, {useState, useContext} from "react";
import styles from "./Contact.module.css";
import AddSvg from "../../components/AddSvg/AddSvg" 
import { LanguageContext } from '../../components/LanguageContext/LanguageContext';
import { translations } from '../../components/LanguageJSON/LanguageJSON';
import axios from 'axios';

const Contact = ()=>{
    const arrow = '<svg version="1.2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#0494d1" /><stop offset="100%" stop-color="#00ff7b" /></linearGradient></defs><g id="Layer_1"><path d="M13.293,7.293c-0.391,0.391-0.391,1.023,0,1.414L15.586,11H8c-0.552,0-1,0.448-1,1s0.448,1,1,1h7.586l-2.293,2.293   c-0.391,0.391-0.391,1.023,0,1.414C13.488,16.902,13.744,17,14,17s0.512-0.098,0.707-0.293L19.414,12l-4.707-4.707   C14.316,6.902,13.684,6.902,13.293,7.293z"/></g></svg>';
    const { currentLang, setCurrentLang } = useContext(LanguageContext);
    const language = translations[currentLang]['contact'];

    function sendMessageBot(e) { 
        let target = e.target;
        target = target.closest('.btn-contact');
        let father = target.closest('.container');
        let name = "";
        let email = "";
        let input = father.querySelectorAll('input');
        let input_name = 0;
        let input_email = 0;
        input.forEach((item, idx)=>{
            if(item.getAttribute('type') == 'name'){
                name = item.value;
                input_name = item
            }
            if(item.getAttribute('type') == 'email'){
                email = item.value;
                input_email = item
            }
        })
        if(name != "" && email != ""){
            target.classList.add('loaded');
            input_name.closest('.form_valid').classList.remove('invalid');
            input_email.closest('.form_valid').classList.remove('invalid');

            const postData = {
                name: name,
                email: email
              };
              
              axios.post('/sendme', postData)
              .then(response => {
                input.forEach((item, idx)=>{
                    item.value = "";
                })
                target.classList.remove('loaded');
              })
              .catch(error => {
                target.classList.remove('loaded');
                console.error('HTTP error!', error);
              });

        }else{
            if(name == ""){
                input_name.closest('.form_valid').classList.add('invalid');
            }else{
                input_name.closest('.form_valid').classList.remove('invalid');
            }

            if(email == ""){
                input_email.closest('.form_valid').classList.add('invalid');
            }else{
                input_name.closest('.form_valid').classList.remove('invalid');
            }
        }
    }

    
    const [activeSections, setActiveSections] = useState([]);
    const toggleAccordion = (sectionIndex, itemIndex) => {
      setActiveSections((prevSections) => {
        const newSections = [...prevSections];
        newSections[sectionIndex] = newSections[sectionIndex] === itemIndex ? null : itemIndex;
        return newSections;
      });
    };
    const FAQ_ARRAY = language.faq

    return (
        <div className={styles.contacts_container}>
            <div className={styles.vector_abstract}></div>
            <div className={"container px-5 px-md-0 " + styles.contact}>
                <div className="row d-flex flex-column">
                    <span id="contacts" name="contacts"></span>
                    <div className="col">
                        <div className={styles.form_contact}>
                            <div className={styles.form_holder}>
                                <h2>{language.request_tile}</h2>
                                <p>{language.request_dsc}</p>
                                <div className="form-group row">
                                    <div className={"form_valid mb-3 col-12 col-md-6 " + styles.form_custom }>
                                        <input type="name" placeholder={language.form_name} />
                                    </div>
                                    <div className={"form_valid mb-3 col-12 col-md-6 " + styles.form_custom }>
                                        <input type="email" placeholder="name@example.com" />
                                    </div>
                                </div>
                                <button onClick={(e) => sendMessageBot(e)} className="btn btn-contact">
                                    <span>{language.button_name}</span>
                                    <div className="loader">
                                        <i></i>
                                    </div>
                                </button>
                                <small>{language.description}</small>
                            </div>
                            <div className={styles.svg_decor}>
                                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="gradient_contact" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#e3ecf0" /><stop offset="100%" stop-color="#00ff7b" /></linearGradient></defs><path d="M21.74 17.024a.485.485 0 0 0-.082-.022l-.007-.005-.064-.044a1.421 1.421 0 0 0-.167-.086 3.031 3.031 0 0 0-.482-.16 7.714 7.714 0 0 1-3.188-1.563 11.456 11.456 0 0 1-3.747-7.174 11.837 11.837 0 0 1-.15-1.204l-.027-.305-.013-.152-.007-.077-.002-.019a.748.748 0 0 0-.028-.162.663.663 0 0 0-1.225-.126.742.742 0 0 0-.08.297l-.007.07c-.057.004-.064.004 0 0l-.001.006-.015.153-.029.307a15.592 15.592 0 0 1-.41 2.43 12.263 12.263 0 0 1-1.972 4.294 8.5 8.5 0 0 1-3.17 2.63l-.635.25c-.309.11-.735.194-.965.293l-.798.28-.388.136c-.066.035-.031.053-.052.08l-.042.146-.021.071a.719.719 0 0 0-.004.088.127.127 0 0 0 .007.054l.077.258a4.967 4.967 0 0 0 .544.367 8.003 8.003 0 0 1 1.918.475l.28.109a1.543 1.543 0 0 1 .227.106l.481.249a8.758 8.758 0 0 1 2.022 1.64 12.273 12.273 0 0 1 2.716 5.675 16.66 16.66 0 0 1 .26 1.754l.044.441.005.055a.747.747 0 0 0 .023.143.59.59 0 0 0 1.116.078.662.662 0 0 0 .049-.213l.002-.028.019-.22.074-.87a15.795 15.795 0 0 1 .738-3.206 10.47 10.47 0 0 1 2.447-4.006 8.044 8.044 0 0 1 3.253-2c.83-.275 1.311-.3 1.395-.388.05-.036-.043-.185.058-.183a.356.356 0 0 0 .282-.41.385.385 0 0 0-.111-.22.415.415 0 0 0-.147-.092ZM27.899 8.733a.383.383 0 0 0-.22-.178c-.115-.026-.037-.018-.066-.029l-.023-.037a.454.454 0 0 0-.062-.069.576.576 0 0 0-.178-.11 4.524 4.524 0 0 1-.578-.2 3.165 3.165 0 0 1-1.162-.956 4.037 4.037 0 0 1-.277-.412l-.129-.23-.157-.339a4.982 4.982 0 0 1-.196-.642c-.06-.242-.13-.424-.18-.732l-.164-.861c-.013-.098-.031-.09-.048-.108l-.052-.045-.105-.092-.101-.086-.055-.024-.1-.043-.047-.018-.011-.005c-.008-.002-.044 0-.035 0l-.023.006c-.014 0-.094.025-.174.048a1.723 1.723 0 0 0-.206.152.568.568 0 0 0-.112.099l-.127.353a7.486 7.486 0 0 1-.416 1.913c-.129.293-.148.327-.206.438l-.166.284a3.405 3.405 0 0 1-.815.893.82.82 0 0 1-.113.08l-.179.118a3.651 3.651 0 0 1-.73.254 3.003 3.003 0 0 0-.363.117l-.317.124c-.164.093-.285.208-.252.258l-.061.168-.007.07a.726.726 0 0 0 .008.157l.054.144.022.057.013.033.085.053.434.27c.263.058.518.145.837.234a1.231 1.231 0 0 1 .392.192l.156.1a3.66 3.66 0 0 1 .652.625 4.093 4.093 0 0 1 .302.437 3.69 3.69 0 0 1 .346.71c.278.706.352 2.067.735 2.218a.277.277 0 0 0 .255.156c.145 0 .401.07.594-.845.17-.811.233-1.24.377-1.709.103-.246.143-.316.184-.407l.146-.255a3.384 3.384 0 0 1 .555-.696 5.382 5.382 0 0 1 1.793-.966c.018-.03-.041-.186.044-.179a.323.323 0 0 0 .229-.488Z"></path></svg>
                            </div>
                        </div>
                    </div>
                    <div className={"col mt-5 " + styles.contact_us}>
                        <h3>Contact us</h3>
                        <h1>{language.contacts.title}</h1>
                        <div className="row mt-4 row-cols-1 row-cols-md-2 row-cols-lg-4 d-flex justify-content-between">
                            <div className={"col py-3 py-md-2 " + styles.contact_method }>
                                <p><AddSvg svg={'<svg data-name="Layer 1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M29.51 15.41c-9.726-1.866-11.054-3.194-12.92-12.92a.6.6 0 0 0-1.18 0c-1.866 9.726-3.194 11.054-12.92 12.92a.6.6 0 0 0 0 1.18c9.726 1.866 11.054 3.194 12.92 12.92a.6.6 0 0 0 1.18 0c1.866-9.726 3.194-11.054 12.92-12.92a.6.6 0 0 0 0-1.18Z" fill="#ffffff" className="fill-000000"></path></svg>'}></AddSvg> Telegram</p>
                                <a href="https://t.me/savwebstudio" className="btn">
                                    <span>{language.contacts.social.send_us}</span>
                                    <span>
                                        <AddSvg svg={arrow}></AddSvg>
                                    </span>
                                </a>
                            </div>
                            <div className={"col py-3 py-md-2 d-flex " + styles.contact_method }>
                                <p><AddSvg svg={'<svg data-name="Layer 1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M29.51 15.41c-9.726-1.866-11.054-3.194-12.92-12.92a.6.6 0 0 0-1.18 0c-1.866 9.726-3.194 11.054-12.92 12.92a.6.6 0 0 0 0 1.18c9.726 1.866 11.054 3.194 12.92 12.92a.6.6 0 0 0 1.18 0c1.866-9.726 3.194-11.054 12.92-12.92a.6.6 0 0 0 0-1.18Z" fill="#ffffff" className="fill-000000"></path></svg>'}></AddSvg> WhatsApp</p>
                                <a href="https://api.whatsapp.com/send?phone=16474621803" className="btn">
                                    <span>{language.contacts.social.send_us}</span>
                                    <span>
                                        <AddSvg svg={arrow}></AddSvg>
                                    </span>
                                </a>
                            </div>
                            <div className={"col py-3 py-md-2 " + styles.contact_method }>
                                <p><AddSvg svg={'<svg data-name="Layer 1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M29.51 15.41c-9.726-1.866-11.054-3.194-12.92-12.92a.6.6 0 0 0-1.18 0c-1.866 9.726-3.194 11.054-12.92 12.92a.6.6 0 0 0 0 1.18c9.726 1.866 11.054 3.194 12.92 12.92a.6.6 0 0 0 1.18 0c1.866-9.726 3.194-11.054 12.92-12.92a.6.6 0 0 0 0-1.18Z" fill="#ffffff" className="fill-000000"></path></svg>'}></AddSvg> Instagram</p>
                                <a href="https://www.instagram.com/savwebstudio/" className="btn">
                                    <span>{language.contacts.social.veiwe_in}</span>
                                    <span>
                                        <AddSvg svg={arrow}></AddSvg>
                                    </span>
                                </a>
                            </div>
                            <div className={"col py-3 py-md-2 " + styles.contact_method }>
                                <p><AddSvg svg={'<svg data-name="Layer 1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M29.51 15.41c-9.726-1.866-11.054-3.194-12.92-12.92a.6.6 0 0 0-1.18 0c-1.866 9.726-3.194 11.054-12.92 12.92a.6.6 0 0 0 0 1.18c9.726 1.866 11.054 3.194 12.92 12.92a.6.6 0 0 0 1.18 0c1.866-9.726 3.194-11.054 12.92-12.92a.6.6 0 0 0 0-1.18Z" fill="#ffffff" className="fill-000000"></path></svg>'}></AddSvg> Email</p>
                                <a href="mailto:request@savweb.studio" className="btn">
                                    <span>{language.contacts.social.send_us}</span>
                                    <AddSvg svg={arrow}></AddSvg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5 pt-5 flex-column align-self-center">
                        <div className="col d-flex flex-column justify-content-center align-items-center">
                            <span className="rounded-section">FAQ</span>
                            <div class="sav_faq">
                                <h1 class="sav-t">{language.faq_title}</h1>

                                {FAQ_ARRAY.map((section, sectionIndex) => (
                                    <div key={sectionIndex} className="accordion">
                                    <h3 className="acc-title">{section['title_section']}</h3>
                                    {section['data'].map((el, itemIndex) => (
                                        <div key={itemIndex} className={`accordion-item ${activeSections[sectionIndex] === itemIndex ? 'active' : ''}`}>
                                        <div className="accordion-header" onClick={() => toggleAccordion(sectionIndex, itemIndex)}>
                                            {el['title']}
                                            <span className="arrow-icon">
                                            <svg fill="none" strokeWidth="1.5" style={{ transform: `rotate(270deg) translateY(-1px) translateX(-1px)` }} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="m15 6-6 6 6 6" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" className="stroke-000000"></path>
                                            </svg>
                                            </span>
                                        </div>
                                        <div className="accordion-content">
                                            {el['description']}
                                        </div>
                                        </div>
                                    ))}
                                    </div>
                                ))}
                                
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Contact